//export const API_URL = process.env.VUE_APP_SERVER_URL;
export const API_URL = 'll';
export default API_URL;
